import React from 'react';

import {motion} from "framer-motion"

import {images} from "../../constants"

import './Header.scss'
import AppWrap from "../../wrapper/AppWrap";

function Header(props) {

    const scaleVariants = {
        whileInView: {
            scale: [0, 1],
            opacity: [0, 1],
            transition: {
                duration: 1,
                ease: "easeInOut"
            }
        }
    }

    return (
        <div className="app__header app__flex">
            <motion.div
                whileInView={{ x: [-100, 0], opacity: [0, 1] }}
                transition={{ duration: .5 }}
                className="app__header-info"
            >
                <div className="app__header-badge">
                    <div className="badge-cmp app__flex">
                        <span>
                            👋
                        </span>
                        <div style={{
                            marginLeft: 20
                        }}>
                            <p className="p-text">
                                Hi, I'm
                            </p>
                            <h1 className="head-text">
                                Oleksandr
                            </h1>
                        </div>
                    </div>
                    <div className="tag-cmp app__flex">
                        <p className="p-text">Fullstack Web Developer</p>
                        <p className="p-text">Freelancer</p>
                    </div>
                </div>
            </motion.div>

            <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: .5, delayChildren: .5 }}
                className="app__header-img"
            >
                <img src={images.profile} alt="profile_bg"/>
                <motion.img
                    whileInView={{ scale: [0, 1] }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className="overlay_circle"
                    src={images.circle}
                    alt={"profile_circle"}
                />
            </motion.div>

            <motion.div
                variant={scaleVariants}
                whileInView={scaleVariants.whileInView}
                className="app__header-circles"
            >
                {[images.react, images.spring, images.java].map((circle, index) => (
                    <div key={`circle-${index}`} className="circle-cmp app__flex">
                        <img src={circle} alt={"circle"}/>
                    </div>
                ))}
            </motion.div>
        </div>
    );
}

export default AppWrap(Header, 'home');